import * as ArrayUtils from "../utils/array-utils";
import * as ObjectUtils from "../utils/object-utils";
import * as StringUtils from "../utils/string-utils";
import { combineURL } from "../utils/url-utils";
import globals from "./global-vars";

export function setPid(pid: any) {
    window.sessionStorage.setItem("pid", pid);
}

/**
 * Gets EXO-PID signed token
 */
export function getPid() {
    return window.sessionStorage.getItem("pid");
}

/**
 * Gets the current project ID as plain text
 */
export function getPidText() {
    return window.sessionStorage.getItem("pid-text");
}

export function splashScreenIntervalHandler() {
    console.log("loading...");
    const splash = $(".splash-screen");
    if (
        $("#grid").length > 0
        && globals.firstDataBound
        || splash.is(":visible")
    ) {
        clearInterval(parseInt(globals.splashIntervalId, 10));
        console.log(globals.splashIntervalId);
        splash.hide();
        $("#defaultFilter input.k-input").prop("disabled", true); // filter bar disable text input
    }
}

/**
 * Gets the URL to the API v2
 * @returns {string}
 */
export function getApiURL(version: string = "v2") {
    return combineURL(
        window.location.origin,
        "TagBrowser/api",
        version,
    ) + "/"; // Tail slash for backward compatibility
}

/**
 *
 * @param {string} control
 * @param {string} action
 * @returns {string}
 */
export function getApiV2Url(control: string, action: string) {
    return combineURL(
        getApiURL("v2"),
        control,
        action,
    );
}

/**
 * Get Ninja API v3 url
 *
 * @param control
 * @param action
 *
 * @deprecated Always use the SDK, this should only be used for debugging
 * @see src/_modules/sdk
 */
export function getApiV3Url(control: string = "", action: string = "") {
    return combineURL(
        getApiURL("v3"),
        control,
        action,
    );
}

/**
 *
 * @param control
 * @param action
 */
export function getMvcUrl(control: string, action: string = ""){
    return combineURL(
        window.location.origin,
        "TagBrowser/",
        control,
        action
    );
}

/**
 * Gets the full URL to TagBrowser root URI
 *
 * @returns {string}
 *
 * @deprecated - Use ROOT_URL instead
 * @see ROOT_URL
 * Decision made with various reasons
 * 1. This is value does not change after the script is loaded, constant is a better suit
 * 2. Remove the trailing "/" as using Template literals,
 *    `${url}/api/v3` IMO is more readable than `${url}api/v3`
 *    (Can you see how the successor string blend into the template variable?)
 */
export function getTagBrowserRootUrl() {
    return window.location.origin + "/TagBrowser/";
}

/**
 * Gets the full URL to Tag Browser root URI
 */
export const ROOT_URL = window.location.origin + "/TagBrowser";

/**
 * Gets the full URL of a Tag Browser resource
 *
 * @param resourceURI The resource URI after `<< domain >>/TagBrowser/`
 */
export function getResourceUrl(resourceURI: string): string {
    return combineURL(ROOT_URL, resourceURI);
}

/**
 * Gets URI to Project Home
 */
export const WODO_HOME_URL = getResourceUrl("Wodo/Home");

export function exc() {
    throw Error("manual throw");
}

/**
 * Interface to represent an object with no requirement on what's inside it
 */
export interface AnyObject {
    [key: string]: any;
}

/**
 * sample fn for jest
 * @return {number}
 */
export function sample() {
    return 1;
}

export { ArrayUtils, ObjectUtils, StringUtils, globals };
